/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import{UnsupportedOperationError}from"../base/error";import isArray from"./isArray";import isPlainObject from"./isPlainObject";const checkType=r=>{if(isArray(r))return!0;if(isPlainObject(r))return!1;throw new UnsupportedOperationError(`No such related function of the type ${r}`)};export default checkType;